import myProfile from "./myProfile"
import subscription from "./subscription"
import organizationInfo from "./organizationInfo"
import statistics from "./statistics"

export default [
    myProfile,
    organizationInfo,
    subscription,
    statistics,
]